import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/primary/auth';
import user from './modules/primary/user';
import insurance from './modules/primary/insurance';
import collectiveAgreements from './modules/primary/collective-agreements';
import financialSummary from './modules/primary/financialSummary';
import admin from './modules/primary/admin';

Vue.use(Vuex)

export default new Vuex.Store({
  modules : {
    auth,
    user,
    insurance,
    collectiveAgreements,
    financialSummary,
    admin,
  }
})
